// extracted by mini-css-extract-plugin
export var animationAbsolute = "_4c-q";
export var animationRelative = "_4c-p";
export var backdropBlur = "_4c-0";
export var detailLabelCell = "_4c-12";
export var detailTable = "_4c-11";
export var detailValueCell = "_4c-13";
export var docIconBox = "_4c-1d";
export var docIconBoxMd = "_4c-1f";
export var docIconBoxSm = "_4c-1e";
export var docTypeRow = "_4c-16";
export var docTypeRowInner = "_4c-17";
export var dropdownMatchDatePicker = "_4c-3";
export var evidenceCardContent = "_4c-1c";
export var fileUploadSpin = "_4c-j";
export var gorgiasOpenButton = "_4c-15 _4c-d";
export var gorgiasTicketCard = "_4c-14";
export var heroModalFooterButton = "_4c-18";
export var hiddenContainer = "_4c-o";
export var iconPrimary = "_4c-1g";
export var iconQuaternary = "_4c-1i";
export var iconTertiary = "_4c-1h";
export var integrationCard = "_4c-1";
export var integrationLogoBox = "_4c-2";
export var mainColumnSticky = "_4c-1b";
export var maxWidthContainer = "_4c-19";
export var modalContentBody = "_4c-a";
export var modalHeaderImage = "_4c-5";
export var modalImageLabel = "_4c-7";
export var modalImageOverlay = "_4c-6";
export var modalImageSubtitle = "_4c-9";
export var modalImageTitle = "_4c-8";
export var modalImageWrapper = "_4c-4";
export var modalStickyFooter = "_4c-b";
export var removeButton = "_4c-e";
export var sidebarColumn = "_4c-1a";
export var spinner = "_4c-i";
export var timelineLine = "_4c-y";
export var timelineLineBlack = "_4c-10 _4c-y";
export var timelineLineGray = "_4c-z _4c-y";
export var timelineLineHeight = "_4c-x";
export var tlDotActivate = "_4c-u";
export var tlDotActivateAnim = "_4c-t";
export var tlDotHide = "_4c-s";
export var tlDotHideAnim = "_4c-r";
export var tlLineActivate = "_4c-w";
export var tlLineActivateAnim = "_4c-v";
export var uploadHint = "_4c-n";
export var uploadIconBox = "_4c-k";
export var uploadLabel = "_4c-m";
export var uploadText = "_4c-l";
export var uploadZone = "_4c-f";
export var uploadZoneCursorDefault = "_4c-h";
export var uploadZoneCursorPointer = "_4c-g";
export var uploadedFileRow = "_4c-c";
export var viewButton = "_4c-d";